import { createAction } from "@reduxjs/toolkit"

const PREFIX = "alert/"
const NOTIFY = `${PREFIX}NOTIFY`
const DISMISS = `${PREFIX}DISMISS`

export const notify = createAction<Alerts.Notification>(NOTIFY)
export const dismiss = createAction(DISMISS)
